/* eslint-disable import/prefer-default-export */

import { FILE_MAX_SIZE_MB } from '@/utils/constants';

const fileMaxSizeMb = FILE_MAX_SIZE_MB;

const isValidFileSize = (base64, maxSizeInMB) => {
  const cleanedBase64 = base64.split(',')[1] || base64;
  const decodedBase64 = atob(cleanedBase64);
  const fileSize = decodedBase64.length;
  const maxSize = maxSizeInMB || fileMaxSizeMb;
  const maxSizeInBytes = maxSize * 1024 * 1024;

  return fileSize <= maxSizeInBytes;
};

const sanitize = (value) => {
  const searchMasks = [
    'FSCommand',
    'onAbort',
    'onActivate',
    'onAfterPrint',
    'onAfterUpdate',
    'onBeforeActivate',
    'onBeforeCopy',
    'onBeforeCut',
    'onBeforeDeactivate',
    'onBeforeEditFocus',
    'onBeforePaste',
    'onBeforePrint',
    'onBeforeUnload',
    'onBeforeUpdate',
    'onBegin',
    'onBlur',
    'onBounce',
    'onCellChange',
    'onChange',
    'onClick',
    'onContextMenu',
    'onControlSelect',
    'onCopy',
    'onCut',
    'onDataAvailable',
    'onDataSetChanged',
    'onDataSetComplete',
    'onDblClick',
    'onDeactivate',
    'onDrag',
    'onDragEnd',
    'onDragLeave',
    'onDragEnter',
    'onDragOver',
    'onDragDrop',
    'onDragStart',
    'onDrop',
    'onEnd',
    'onError',
    'onErrorUpdate',
    'onFilterChange',
    'onFinish',
    'onFocus',
    'onFocusIn',
    'onFocusOut',
    'onHashChange',
    'onHelp',
    'onInput',
    'onKeyDown',
    'onKeyPress',
    'onKeyUp',
    'onLayoutComplete',
    'onLoad',
    'onLoseCapture',
    'onMediaComplete',
    'onMediaError',
    'onMessage',
    'onMouseDown',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseOut',
    'onMouseOver',
    'onMouseUp',
    'onMouseWheel',
    'onMove',
    'onMoveEnd',
    'onMoveStart',
    'onOffline',
    'onOnline',
    'onOutOfSync',
    'onPaste',
    'onPause',
    'onPopState',
    'onProgress',
    'onPropertyChange',
    'onReadyStateChange',
    'onRedo',
    'onRepeat',
    'onReset',
    'onResize',
    'onResizeEnd',
    'onResizeStart',
    'onResume',
    'onReverse',
    'onRowsEnter',
    'onRowExit',
    'onRowDelete',
    'onRowInserted',
    'onScroll',
    'onSeek',
    'onSelect',
    'onSelectionChange',
    'onSelectStart',
    'onStart',
    'onStop',
    'onStorage',
    'onSyncRestored',
    'onSubmit',
    'onTimeError',
    'onTrackChange',
    'onUndo',
    'onUnload',
    'onURLFlip',
    'seekSegmentTime',
  ];

  return searchMasks.reduce(
    (acc, mask) => acc.replace(new RegExp(mask, 'ig'), ''), value || '',
  );
};

export {
  isValidFileSize,
  sanitize,
};
